<template>
    <div>
        <div v-if="cases.length">
            <table class="table">
                <thead class="thead-dark">
                    <tr>
                    <th scope="col">#</th>
                    <th scope="col">Имя</th>
                    <th scope="col">Заголовок</th>
                    <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in cases" :key="item.id">
                        <th scope="row">{{ item.id }}</th>
                        <td>{{ item.name[lang()] }}</td>
                        <td>{{ item.header[lang()] }}</td>
                        <td>
                            <button class="btn btn-info" @click="edit(item)">
                                <img src="../../assets/edit.png" title="edit" style="width: 20px;">
                            </button>
                            <button class="btn btn-danger" @click="delModal(item)">
                                <img src="../../assets/clean.png" title="delete" style="width: 20px;">
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else style="text-align: center; padding: 1rem; color: grey;">
            <span>ПУСТО</span>
        </div>

        <div>
            <button class="btn btn-success" 
                style="width: 100%"
                @click="add"
            >
                добавить
            </button>
        </div>
        <modal v-if="showAddModal" @off="showAddModal = false;" >
            <addCase @saved="saved" />
        </modal>
        <modal v-if="showDeleteModal" @off="showDeleteModal = false">
            <deleteCase :delData="delData" @del="del" />
        </modal>
        <modal v-if="showEditModal" @off="showEditModal = false">
            <editCase :editData="editData" @saved="saveEdit" />
        </modal>
    </div>
</template>

<script>
import { store } from '../../store';

import modal from '../modal.vue';
import addCase from './addCase.vue';
import deleteCase from './deleteCase.vue';
import Data from '../../API';
import editCase from './editCase.vue'
export default {
    components: {
        modal,
        addCase,
        deleteCase,
        editCase
    },
    data() {
        return {
            showAddModal: false,
            showDeleteModal: false,
            delData: null,
            showEditModal: false
        }
    },
    methods: {
        lang() {
            return localStorage.getItem('lang')
        },
        updateData() {
             Data.getStart()
                .then(json => {
                    store.getStart = json.data.data;
                })
        },
        add() {
            this.showAddModal = true;
        },
        saved() {
            this.showAddModal = false;
            this.updateData();
           
        },
        delModal(item) {
            this.delData = item;
            this.showDeleteModal = true;
        },
        saveEdit() {
            this.showEditModal = false;
            this.updateData();
        },
        del() {
            this.showDeleteModal = false;
            this.updateData();
        },
        edit(item) {
            this.editData = item;
            this.showEditModal = true;
        }
    },
    computed: {
        cases() {
            return store.getStart.cases_data
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/case/CaseAdmin.vue